import { render, staticRenderFns } from "./markBox.vue?vue&type=template&id=a15ae14c&scoped=true&"
import script from "./markBox.vue?vue&type=script&lang=js&"
export * from "./markBox.vue?vue&type=script&lang=js&"
import style0 from "./markBox.vue?vue&type=style&index=0&id=a15ae14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15ae14c",
  null
  
)

export default component.exports